/**
 * メインページを開く
 */
export const openMain = (selector) => {
    const mainEl = document.querySelector('.main');
    if (mainEl === null) {
        return;
    }
    // 終了
    mainEl.addEventListener('transitionend', () => {
        mainEl.classList.remove('enter');
        mainEl.classList.remove('enter-active');
    });
    // アニメーション開始
    mainEl.classList.add('enter-active');
};
